import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import { resetPassword } from '../../Accounts/API'
import Checkmark from '../../../../img/check_mark_in_circle.svg'
import { setDialog as setDialogConnect } from '../../../actions/navigation'
import Modal from '../Modal'

export default () => {
    const [email, setEmail] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [success, setSuccess] = useState(false)

    const dispatch = useDispatch()
    const setDialog = dialogName => dispatch(setDialogConnect(dialogName))

    const handleSubmit = async e => {
        e.preventDefault()
        setErrorMessage('')

        try {
            await resetPassword(email.toLowerCase())
        } catch (error) {
            if (error.response.data === 'bad-email') {
                setErrorMessage(<p>Please enter a valid email address.</p>)
                return
            }
            if (error.response.data === 'user-does-not-exist') {
                setErrorMessage(
                    <>
                        <p>No user associated with this email account ({email}) exists.</p>
                        <p className="suggestion">
                            Don&#39;t have an account yet?
                            <a onClick={() => setDialog('createAccount')}> Sign up. </a>
                        </p>
                    </>
                )
                return
            }
            setErrorMessage(<p>There was an error resetting the password for this account.</p>)
            return
        }

        setSuccess(true)
    }

    return (
        <Modal>
            <div className="form-modal">
                <header>
                    <h2>Reset your password</h2>
                    <p>
                        Enter the email associated with your account and we’ll send an email containing instructions to
                        reset your password.
                    </p>
                </header>
                <form className={success ? 'collapsible hide' : 'collapsible'} method="post" onSubmit={handleSubmit}>
                    {errorMessage && <div className="error">{errorMessage}</div>}
                    <label>
                        Email
                        <input
                            autoFocus
                            type="text"
                            name="email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />
                    </label>
                    <button type="submit" className="button is-primary" disabled={!email}>
                        Send Instructions
                    </button>
                </form>
                <div className={success ? 'success-message' : 'success-message hide'}>
                    <div>
                        <Checkmark />
                        <p>
                            We'll send an email with further instructions to {email} if an account matches that address.
                        </p>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
